export enum ExperienceGrandTotalType {
    Construction = 0,
    FixFlip = 1,
    Rental = 2,
    BFIRepaymentsLast5Years = 3,
}

export const ExperienceGrandTotalTypeOptions = [
    {
        id: ExperienceGrandTotalType.Construction,
        name: 'Construction',
    },
    {
        id: ExperienceGrandTotalType.FixFlip,
        name: 'Fix-Flip',
    },
    {
        id: ExperienceGrandTotalType.Rental,
        name: 'Rental',
    },
    {
        id: ExperienceGrandTotalType.BFIRepaymentsLast5Years,
        name: 'BFI Repayments (Past 5 years)',
    },
];
